import React from 'react'
import FormCarouselSettings from 'components/forms/image/FormCarouselSettings'
import { updateObject } from 'helpers/objectHelpers';

const ProductSliderSettings = ({
  value,
  value: {
    slider,
  },
  onChange,
}) => {
  const handleUpdate = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <FormCarouselSettings
      value={slider}
      onChange={(val) => handleUpdate(val, 'slider')}
    />
  )
}

ProductSliderSettings.propTypes = {}
ProductSliderSettings.defaultProps = {}

export default ProductSliderSettings



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/productSlider/ProductSliderSettings.js